import { useContext, useEffect } from '@wordpress/element';

import { DesignContext } from '@components/DesignPanel/DesignStore';
import { useStore } from 'zustand';

const useEmitBiteObject = ({ emitDesign }: any) => {
  const store = useContext(DesignContext);
  const { currentDesign, currentClass } = useStore(store);

  useEffect(() => {
    emitDesign({
      currentStyle: currentDesign,
      currentClass: currentClass,
    });
  }, [currentClass, currentDesign.length]);
};

export default useEmitBiteObject;
